import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '@env/environment';
import { Service } from './service';

/**
 * Angular HTTP Client request options including headers
 */
const httpOptions = {
  headers: new HttpHeaders({
    Accept: 'application/json',
    'Content-Type': 'application/json',
  }),
};

/**
 * PassThroughService
 *
 * @export PassThroughService
 */
@Injectable({
  providedIn: 'root',
})
export class PassThroughService implements Service {

  /**
   * Instance of pass through service endpoint url.
   * This service only exists on production currently
   */
  private url = environment.passThroughAPI;

  /**
   * Creates an instance of the PassThroughService
   *
   * @param http used for HTTP requests
   */
  constructor(private http: HttpClient) {}

  /**
   * Accounts
   *
   * @param email param used to search for matching email
   * @returns An Array of Customer type objects
   */
  public accounts(
    email: string,
    hardReload?: boolean,
  ): Observable<any> {
    return this.http.get<any>(this.url + '/accounts?email=' + email);
  }

  /**
   * HealthCheck
   *
   * @returns returns 200OK if the health check succeeds or an error if it fails
   */
  public healthCheck(val?: string): Observable<any> {
    const endCheck: string = val || 'users-api';
    return this.http.get<any>(`${this.url}/status/${endCheck}`);
  }

  /**
   * Fetches the most up to date information about the SmartFeed devices firmware
   *
   * @returns async JSON object with firmware information
   */
  public getSmartFeedFirmware(): Observable<any> {
    return this.http.get<any>(
      `https://cdn.ps-smartfeed.cloud.petsafe.net/software-versions/ps-smartfeed-firmware.json?v='${new Date().getTime()}`,
      httpOptions,
    );
  }
}
